export default {"src":"/_next/static/media/Logo_white.e5d436c4.svg","height":61,"width":151};